import { render, staticRenderFns } from "./Adminhome.vue?vue&type=template&id=68a66bb4&"
import script from "./Adminhome.vue?vue&type=script&lang=js&"
export * from "./Adminhome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports